import { useGLTF } from "@react-three/drei";
import { RigidBody, CuboidCollider } from "@react-three/rapier";
import { MODELS } from "../loader/models.js";

const PointerGameZone = ({ position = [0, 0, 0], rotation = [0, 0, 0] }) => {
  const { scene } = useGLTF(MODELS.POINTER_GAME_ZONE);

  return (
    <group position={position} rotation={rotation}>
      <primitive scale={1.5} object={scene} position-x={-0.8} />
      <group position={[-0.5, 4, 0.25]}>
        <RigidBody type="fixed" ccd={false}>
          <CuboidCollider args={[0.5, 0.2, 1.5]} />
        </RigidBody>
      </group>
    </group>
  );
};

export default PointerGameZone;
